import bankInfo from './bankInfo'

export * from './bankInfo'
export default bankInfo
